module.exports = __webpack_public_path__ + "static/img/clothing_04.a4319b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_04.png
// module id = QR6O
// module chunks = 0